import type { ConfiguratorPageDefinition } from "~/features/configurator/ConfiguratorPageDefinition";
import { CARRIAGE_DEFINITION } from "~/features/configurator/Carriage/CarriageConfigurationPage";
import { KWLT_CARRIAGE_DEFINITION } from "~/features/configurator/Carriage/v2/configuration/kwlt/KWLTCarriageConfigurationPage";
import { RAIL_DEFINITION } from "~/features/configurator/Rail/v2/configuration/classic/RailConfigurationPage";
import { LC_DEFINITION } from "~/features/configurator/Linear/v2/configuration/classic/UnitConfiguratorPage";
import { KLLT_UNIT_DEFINITION } from "~/features/configurator/Linear/v2/configuration/kllt/KLLTUnitConfigurationPage";
import { KUEM_UNIT_DEFINITION } from "~/features/configurator/Linear/v2/configuration/kuem/KUEMUnitConfigurationPage";
import { METRIC_SHAFT_DEFINITION } from "~/features/configurator/Shaft/v2/configuration/MetricShaftConfiguratorPage";
import { IMPERIAL_SHAFT_DEFINITION } from "~/features/configurator/Shaft/v2/configuration/ImperialShaftConfiguratorPage";
import { TKDM_RAIL_DEFINITION } from "~/features/configurator/Rail/v2/configuration/tkdm/TKDMRailConfigurationPage";
import { TKLT_RAIL_DEFINITION } from "~/features/configurator/Rail/v2/configuration/tklt/TKLTRailConfigurationPage";

export const CONFIGURATOR_DEFINITIONS = [
  CARRIAGE_DEFINITION,
  KWLT_CARRIAGE_DEFINITION,
  RAIL_DEFINITION,
  TKDM_RAIL_DEFINITION,
  TKLT_RAIL_DEFINITION,
  LC_DEFINITION,
  KLLT_UNIT_DEFINITION,
  KUEM_UNIT_DEFINITION,
  METRIC_SHAFT_DEFINITION,
  IMPERIAL_SHAFT_DEFINITION,
] as const;

export function getConfiguratorDefinition(productCode: string): ConfiguratorPageDefinition {
  const definition = CONFIGURATOR_DEFINITIONS.find((d) => d.productCode === productCode);
  if (!definition) {
    throw new Error(`No configurator definition registered for productCode: ${productCode}`);
  }
  return definition;
}

export function getAllConfiguratorDefinitions(): readonly ConfiguratorPageDefinition[] {
  return CONFIGURATOR_DEFINITIONS;
}
